import { createFileRoute } from '@tanstack/react-router'
import { QrCode } from 'lucide-react'
import { OrgViewBar } from '@/components/shell/org-view-bar'
import { GroupsBrowserContainer } from '@/components/groups/groups-browser-container'
import { NewQrCodeDialog } from '@/components/qr/new-qr-code-dialog'
import { BrowserSkeleton, ViewBarSkeleton } from '@/components/shell/screen-skeletons'

export const Route = createFileRoute('/o/$org/qr-codes/')({
  pendingComponent: () => (
    <>
      <ViewBarSkeleton />
      <BrowserSkeleton />
    </>
  ),
  component: QrCodesScreen,
})

/**
 * All QR codes in the organization.
 *
 * No fetching here. The org route already prefetched the codes, the groups and
 * the link template into the query cache, so everything below reads that one
 * cache entry rather than issuing a second round of requests.
 */
function QrCodesScreen() {
  return (
    <>
      <OrgViewBar
        icon={<QrCode />}
        iconColor="rgb(250, 140, 22)"
        title="All QR Codes"
        actions={<NewQrCodeDialog />}
      />

      <GroupsBrowserContainer
        groupId={null}
        codesTitle="QR codes"
        codesBlurb="Every code in this workspace, grouped or not."
      />
    </>
  )
}
